import React, { Component } from 'react'
import { connect } from 'react-redux'
import { toast } from 'react-toastify'
import Modal from '../Shared/Modal'
import ModalHeader from '../Shared/ModalHeader'
import ModalButtonStrip from '../Shared/ModalButtonStrip'
import ModalBody from '../Shared/ModalBody'
import ModalFooter from '../Shared/ModalFooter'
import SelectorInput from '../../components/Shared/SelectorInput'
import Box from '../Layout/Box'
import BoxButton from '../Layout/BoxButton'

import { 
	displayModalAddServicio,
	updateInputs,
	addSolicitudServicioItem,
	addCencoSolicitudServicioItem,
	removeCencosSolicitudServicioItem
} from '../../actions/solicitudservicio'


import { showModalSelector, selectFromSelector } from '../../actions/common'



class ModalAddServicio extends Component {
	
	handleCloseModal = (e) => {

		const modal = document.getElementById('modalAddServicio')
		modal.classList.remove('fadeIn')
		modal.classList.add('fadeOut')

		const modalDialog = document.querySelector(`#modalAddServicio .modal-dialog`)
		modalDialog.classList.remove('zoomIn')
		modalDialog.classList.add('zoomOut')

		setTimeout(() => this.props.displayModalAddServicio(false), 300)
	}


    handleOpenSelector = (path, index) => {

        let columns = [
            { id: 1, caption: 'Identificacion', value: 'username', width: '30%' },
            { id: 2, caption: 'Nombre', value: 'fullname', width: '70%' }
		]
		
		const payload = {}
		

        const fn = (a) => {

            payload.path = path
			payload.value = a			

			this.props.selectFromSelector('MODIFICAR_INPUTS_SOLICITUD_SERVICIO1', payload)

			this.props.updateInputs(`modalAddServicio.data.cencos.${index}.id`, null)
			this.props.updateInputs(`modalAddServicio.data.cencos.${index}.codigo`, null)
			this.props.updateInputs(`modalAddServicio.data.cencos.${index}.descripcion`, null)
			this.props.updateInputs(`modalAddServicio.data.cencos.${index}.responsable_id`, a.id)
			this.props.updateInputs(`modalAddServicio.data.cencos.${index}.pivot.cenco_id`, null)
			

        }
        this.props.showModalSelector('Listado de usuarios', columns, '/usuarios/cencos', fn)
    }



    handleOpenSelectorAddCenco = (list, cenco_idx) => {

        let columns = [
            { id: 1, caption: 'Codigo', value: 'codigo', width: '30%' },
            { id: 2, caption: 'Descripcion', value: 'descripcion', width: '70%' }   
		]

		const cenco = this.props.modalAddServicio.getIn(['data', 'cencos', cenco_idx]).toJS()

        const payload = {}
        const fn = (a) => {

			const index = this.props.modalAddServicio.getIn(['data', 'cencos']).findIndex(c => c.getIn(['cenco', 'id']) == a.id)

			if (index >= 0) {

				toast.warn(`El cenco ${a.codigo} ya se encuentra en el listado`, { bodyClassName: 'toastify-content toastify-warning' })
				
            } else {	

				cenco.id = a.id
				cenco.codigo = a.codigo
				cenco.descripcion = a.descripcion

				payload.path = list
				payload.value = cenco

				this.props.selectFromSelector('MODIFICAR_INPUTS_SOLICITUD_SERVICIO1', payload)
				this.props.updateInputs(`modalAddServicio.data.cencos.${cenco_idx}.pivot.cenco_id`, a.id)
			}


		}

		const customFilter = { column: 'T0.responsable_id', operator: '===', value: this.props.modalAddServicio.getIn(['data', 'cencos', cenco_idx, 'usuario', 'id']), comparison: 'string' }
        this.props.showModalSelector('Listado de CENCOS', columns, '/cencos', fn, customFilter)
	}



	
	render() {

		const { modalAddServicio } = this.props

		if (!modalAddServicio.get('show')) {
			return null
		}


		const boxActions = [
            <BoxButton key="ba[0][0]" size={14} name="plus-circle" onClick={ e => this.props.addCencoSolicitudServicioItem() } title="Nueva" />,
            <BoxButton key="ba[0][1]" size={14} name="trash" onClick={ e => this.props.removeCencosSolicitudServicioItem() } title="Eliminar" disabled={ modalAddServicio.getIn(['data', 'cencos']).filter(x => x.get('selected')).count() === 0 } danger/>,
		]

		
		return(
			<Modal id="modalAddServicio" show={ true } zindex={ 2000 } width={ 800 } >
				<ModalHeader title={ modalAddServicio.get('title') } onClose={ (e) => this.handleCloseModal(e) } />
				<ModalButtonStrip>
					<BoxButton name="check" disabled={ modalAddServicio.get('btnDisabled') } title="Aceptar" onClick={ () => this.props.addSolicitudServicioItem() } />
				</ModalButtonStrip>
				<ModalBody >
					<div>
						<div className="row">
							<div className="col-md-12">
								<div className="form-group">
									<label className="control-label">Descripción</label>
									<textarea id="Descripcion" className="form-control input-sm" value={  modalAddServicio.getIn(['data', 'descripcion'])  } onChange={ (e) => this.props.updateInputs('modalAddServicio.data.descripcion', e.target.value) } rows={ 3 } />
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col-md-4">
								<div className="form-group">
									<label className="control-label">Cantidad</label>
									<input type="number" className="form-control input-sm" value={ modalAddServicio.getIn(['data', 'cantidad']) } onChange={ (e) => this.props.updateInputs('modalAddServicio.data.cantidad', e.target.value) } />
								</div>
							</div>
						</div>
						<br/>
						<div className="row">
							<div className="col-md-12">
								<Box title="Centros de costo" actions={ boxActions } onModal>
									<div className="box-content" style={{ height: '81px', overflowX: 'hidden' }}>
										<table className="table table-condensed">
											<tbody>
												{
													modalAddServicio.getIn(['data', 'cencos']).map((x, n) => {
														return (
															<tr key={ `tr[${x.get('guid')}]` }  className={ x.get('selected') ? 'info-dark' : '' } >

																<td style={{ width: '20px' }} ><input type="checkbox" style={{ marginTop: '6px' }} checked={ x.getIn('selected') } onChange={ (e) => this.props.updateInputs(`modalAddServicio.data.cencos.${n}.selected`, e.target.checked) } /></td>

																<td style={{ width: '20px', verticalAlign: 'middle' }} ><span>{ n + 1 }</span></td>

																<td style={{ width: '50%' }}>
																	<SelectorInput value={ x.getIn(['usuario', 'fullname']) || '' } onClick={ () => this.handleOpenSelector(`modalAddServicio.data.cencos.${n}.usuario`, n) } onReset={ () => this.props.updateInputs(`modalAddServicio.data.cencos.${n}.usuario`, null) } />
																</td>

																<td style={{ width: '30%' }}>
																	{
																		x.get('usuario') ? (
																			<SelectorInput value={ x.get('descripcion') || '' } onClick={ () => this.handleOpenSelectorAddCenco(`modalAddServicio.data.cencos.${n}`, n) } onReset={ () => this.props.updateInputs(`modalAddServicio.data.cencos.${n}`, null) }/>
																		) : (
																			<input className="form-control input-sm" placeholder="Seleccione un responsable del cenco" disabled />
																		)
																	}
																</td>

																<td style={{ width: '20%' }}><input type="number" className="form-control input-sm" placeholder="Porcentaje" value={ x.getIn(['pivot', 'porcentaje']) } onChange={ (e) => this.props.updateInputs(`modalAddServicio.data.cencos.${n}.pivot.porcentaje`, e.target.value) } disabled={ x.get('usuario') == null } /></td>
																<td style={{ width: '20px', verticalAlign: 'middle' }}>%</td>
															</tr>
														)
													})
												}
											</tbody>
										</table>
									</div>
								</Box>
							</div>
						</div>
					</div>
				</ModalBody >
				<ModalFooter >
				</ModalFooter>
			</Modal>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		modalAddServicio: state.solicitudservicio.get('modalAddServicio'),
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		displayModalAddServicio: (show) => dispatch(displayModalAddServicio(show)),
		showModalSelector: (title, fields, url, action, customFilter) => dispatch(showModalSelector(title, fields, url, action, customFilter)),
		selectFromSelector: (type, payload) => dispatch(selectFromSelector(type, payload)),
		updateInputs: (path, value) => dispatch(updateInputs(path, value)),
		addSolicitudServicioItem: () => dispatch(addSolicitudServicioItem()),
		addCencoSolicitudServicioItem: () => dispatch(addCencoSolicitudServicioItem()),
		removeCencosSolicitudServicioItem: () => dispatch(removeCencosSolicitudServicioItem()),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalAddServicio)



// WEBPACK FOOTER //
// ./src/components/SolicitudServicio/ModalAddServicio.jsx